module.exports = __webpack_public_path__ + "static/media/background-711.7cf00265.jpg";